<template>
    <div 
        class="z-40 transition-all duration-300 ease-in-out" 
        :class="[
            positions[props.position] || positions['bottom-right'], 
            classes,
            isSideMenuOpenOnMobile ? 'opacity-0 pointer-events-none' : ''
        ]"
        :style="containerStyle"
    >
        <slot></slot>
    </div>
</template>
<script setup>
import { defineProps, computed, ref, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import appStore from '@/store/app.store'
import sideMenuStore from '@/store/sidemenu.store'
import { isMobile } from '@/service/utility'

const props = defineProps({
    position: {
        type: String,
        default: 'bottom-right'
    },
    fixed: {
        type: Boolean,
        default: true
    }
})

const route = useRoute()

const isSmallScreen = ref(typeof window !== 'undefined' ? window.innerWidth < 768 : false)
const updateScreenSize = () => {
    isSmallScreen.value = typeof window !== 'undefined' ? window.innerWidth < 768 : false
}

onMounted(() => {
    if (typeof window !== 'undefined') {
        window.addEventListener('resize', updateScreenSize)
    }
})

onUnmounted(() => {
    if (typeof window !== 'undefined') {
        window.removeEventListener('resize', updateScreenSize)
    }
})

const isStageView = computed(() => {
    return route.name === 'Playlist Songs' || 
           (route.path && route.path.includes('/song/')) || 
           route.name === 'Live' || 
           route.name === 'Presentation' || 
           route.name === 'Presentation Controller'
})

const positions = {
    'bottom-right': 'right-3 sm:right-4 md:right-6 flex flex-row items-end gap-1.5 sm:gap-2 md:gap-4',
    'bottom-left': 'left-3 sm:left-4 md:left-6 flex flex-row-reverse items-end gap-1.5 sm:gap-2 md:gap-4',
    'top-right': 'top-4 md:top-6 right-4 md:right-6 flex flex-row md:gap-4 gap-2',
    'top-left': 'top-4 md:top-6 left-4 md:left-6 flex flex-row-reverse md:gap-4 gap-2',
}

const classes = computed(() => {
    return {
        'fixed': props.fixed,
        'absolute': !props.fixed
    }
})

const containerStyle = computed(() => {
    if (props.position.startsWith('bottom')) {
        if (isStageView.value && !appStore.state.focusMode && isSmallScreen.value) {
            return {
                bottom: 'max(4.5rem, calc(var(--sab, env(safe-area-inset-bottom, 0px)) + 4.25rem))'
            }
        }
        return {
            bottom: 'max(1rem, calc(var(--sab, env(safe-area-inset-bottom, 0px)) + 1rem))'
        }
    }
    return {}
})

const isSideMenuOpenOnMobile = computed(() => {
    return (isSmallScreen.value || isMobile()) && sideMenuStore.state.open
})
</script>